import React from "react";
import { Navigate } from "react-router-dom";
import PageTourOverlay from "./PageTourOverlay";

/**
 * ProtectedRoute component that checks if user is authenticated
 * Redirects to login page if token is missing or invalid
 */
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  const isAuthenticated = token && token !== "FIRST_TIME_LOGIN" && token.trim() !== "";

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      {children}
      <PageTourOverlay />
    </>
  );
};

export default ProtectedRoute;
